(function () {
	'use strict';

    angular.module("imApp").factory("pohService", ['$ihttp', function ($ihttp) {
		let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1353,
                    parameters: parms || {}
                });
            },
            listComponents: function (parms) {
                return $ihttp.post({
                    method: 1355,
                    parameters: parms || {}
                });
            },
            listProductionOrders: function (parms) {
                return $ihttp.post({
                    method: 1993,
                    parameters: parms || {}
                });
            },
            cancelCaseQtyOl: function (menu) {
                return $ihttp.post({
                    method: 2321,
                    parameters: menu
                });
            },
            cancelCaseQty: function (menu) {
                return $ihttp.post({
                    method: 2322,
                    parameters: menu
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 2427,
                    parameters: menu
                });
            },
            getStatusBtnState: function (menu) {
                return $ihttp.post({
                    method: 2440,
                    parameters: menu
                });
            },
            createProductionOrderFinish: function (menu) {
                return $ihttp.post({
                    method: 3206,
                    parameters: menu
                });
            }
		};

		return service;
	}]);
})();
